/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Gift_Regalar_BtnInputs */

const es_gift_regalar_btn = /** @type {(inputs: Gift_Regalar_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Regalar ${i?.amount} €`)
};

const gl_gift_regalar_btn = /** @type {(inputs: Gift_Regalar_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agasallar ${i?.amount} €`)
};

const en_gift_regalar_btn = /** @type {(inputs: Gift_Regalar_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gift ${i?.amount} €`)
};

/**
* | output |
* | --- |
* | "Gift {amount} €" |
*
* @param {Gift_Regalar_BtnInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_regalar_btn = /** @type {((inputs: Gift_Regalar_BtnInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Regalar_BtnInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_regalar_btn(inputs)
	if (locale === "en") return en_gift_regalar_btn(inputs)
	return es_gift_regalar_btn(inputs)
});